module.exports = __webpack_public_path__ + "img/tg.5e565ac5.svg";